const PHONE = "918180064540";

export const openWhatsApp = (message) => {
  console.log("WhatsApp Click:", message);
  const url = `https://wa.me/${PHONE}?text=${encodeURIComponent(message)}`;
  window.location.href = url;
};

// Category-specific messages
export const WHATSAPP_MESSAGES = {
  homepage: "Hi, I want structured guidance for my protocol. Please help me get started.",
  product: (name) => `Hi, I'm interested in ${name}. Can you guide me on how to use it in a protocol?`,
  cart: "Hi, I have added products to my cart. Can you help me finalize the right protocol before checkout?",
  checkout: "Hi, I'm about to place an order but need help confirming my protocol.",
  exitIntent: "Hi, I was browsing your site and want help choosing the right protocol for my goals.",
  fatLoss: "Hi, I want help with a fat loss protocol.",
  brainFocus: "Hi, I want help improving focus and mental performance.",
  sleep: "Hi, I need help fixing my sleep.",
  recovery: "Hi, I want help with a recovery and repair protocol.",
  longevity: "Hi, I want help with a longevity and anti-aging protocol.",
  hormonal: "Hi, I want help with hormonal balance and optimization.",
  immune: "Hi, I want help with immune support and gut health.",
};
